import React from "react";

const About = () => {
  return (
    <div className="about-area inc-shape default-padding">
      <div className="container">
        <div className="row align-items-center">
          {/* Image Column */}
          <div className="col-lg-6 col-md-6 col-sm-12 mb-4 mb-lg-0">
            <div className="thumb position-relative text-center">
              <img
                decoding="async"
                src="https://wpriverthemes.com/tandaelem/wp-content/uploads/2022/01/1.jpg"
                alt="Thumb 1"
                className="img-fluid mb-3"
              />
              <img
                decoding="async"
                src="https://wpriverthemes.com/tandaelem/wp-content/uploads/2022/01/2-1.jpg"
                alt="Thumb 2"
                className="img-fluid"
              />
              <div className="overlay">
                <div className="content">
                  <h4>AI-Driven Automation</h4>
                </div>
              </div>
            </div>
          </div>

          {/* Text Content Column */}
          <div className="col-lg-5 offset-lg-1 col-md-6 col-sm-12 info">
            <h2>We help Staffing Agencies to Scale</h2>
            <p>
              Manual resume screening is time-consuming & inefficient. Evaluating candidates through traditional methods
              lacks speed & accuracy. Managing job submissions, candidates, and vendors is often disorganized.
            </p>
            <ul className="list-icons">
              <li>
                <div className="icon">
                  <i className="fa fa-robot"></i>
                </div>
                <div className="info">
                  <p>
                    AI-driven automation to streamline the hiring process. Smart candidate matching to improve quality & reduce hiring time.
                  </p>
                </div>
              </li>
              <li>
                <div className="icon">
                  <i className="fa fa-user"></i>
                </div>
                <div className="info">
                  <p>
                    End-to-end staffing management on a single platform.
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* CSS Styling */}
      <style jsx>{`
        .default-padding {
          padding-top: 60px;
          padding-bottom: 60px;
        }

        .about-area .info h2 {
          font-weight: 600;
          margin-bottom: 25px;
          color: #00a7ac;
          margin-top: 80px;
        }

        .about-area .info p {
          font-size: 16px;
          color: #666;
          line-height: 26px;
        }

        .about-area .thumb {
          position: relative;
        }

        .about-area .thumb img {
          border-radius: 8px;
          max-width: 100%;
        }

        .about-area .thumb img:first-child {
          width: 80%;
        }

        .about-area .thumb img:nth-child(2) {
          position: relative;
          left: 20%;
          width: 80%;
          top: -80px;
          margin-bottom: -80px;
          box-shadow: 0 0 10px #cccccc;
          padding: 5px;
          background: #ffffff;
        }

        .about-area .thumb .overlay {
          position: absolute;
          right: 0;
          top: 50%;
          height: 250px;
          width: 250px;
          text-align: center;
          background: #ffffff;
          transform: translate(50px, -50%);
          border-radius: 8px;
          box-shadow: 0 0 10px #cccccc;
        }

        .about-area .thumb .overlay .content {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          width: 100%;
          padding: 0 30px;
        }

        .about-area .thumb .overlay h4 {
          margin: 0;
          font-weight: 700;
          text-transform: capitalize;
          line-height: 1.4;
        }

        .about-area .info ul {
          margin-top: 30px;
          list-style: none;
          padding: 0;
        }

        .about-area .info ul li {
          display: flex;
          align-items: flex-start;
          margin-bottom: 20px;
        }

        .about-area .icon i {
          font-size: 36px;
          color: #00a7ac;
          margin-right: 15px;
          min-width: 36px;
        }

        @media (max-width: 768px) {
          .about-area .info h2 {
            margin-top: 40px;
            font-size: 24px;
          }

          .about-area .info p {
            font-size: 14px;
            line-height: 24px;
          }

          .about-area .thumb img:first-child,
          .about-area .thumb img:nth-child(2) {
            width: 90%;
            left: 0;
          }

          .about-area .thumb .overlay {
            position: static;
            transform: none;
            margin: 20px auto 0;
            width: 90%;
            height: auto;
            padding: 20px;
          }

          .about-area .thumb .overlay .content {
            position: static;
            transform: none;
            padding: 0;
          }

          .about-area .thumb .overlay h4 {
            font-size: 16px;
          }
        }
      `}</style>
    </div>
  );
};

export default About;
